/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import clsx from 'clsx'
import {useHomeQueryResponse} from './provider/HomeResponseProvider'
import {HOME_PAGE_CONTEXT_KEY, useHomeQueryRequest} from './provider/HomeRequestProvider'
import ProjectListHeader from '../../modules/apps/project/components/ProjectList/ProjectListHeader'
import ProjectTable from '../../modules/apps/project/components/ProjectList/ProjectTable'
import {parseHomeDataToTable} from './helpers/homeDataTable'
import {useNavigate} from 'react-router-dom'
import {useThemeMode} from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {setProjectEditing} from '../../common/ModalPopup/reducer'
import {useDispatch} from 'react-redux'

const HomePage = () => {
  const dispatch = useDispatch()
  const homeContext = localStorage.getItem(HOME_PAGE_CONTEXT_KEY)
  let hpdc: any = {}
  if (homeContext) {
    hpdc = JSON.parse(homeContext)
  }
  const {response: data} = useHomeQueryResponse()
  const {updateState, state} = useHomeQueryRequest()
  const {mode} = useThemeMode()
  const navigate = useNavigate()
  const [activeSort, setActiveSort] = useState<any>({
    Sort: 'LastModificationDate',
    Order: 'asc',
    ...hpdc,
  })
  const onAddPress = () => {
    navigate('/new-project/tab1')
  }
  const tHeader: any = {
    columns: [
      {
        colIndex: 0,
        dataKey: 'LastModificationDate',
        rowGuid: 'HeaderTC',
        rowIndex: 0,
        type: 'text',
        value: 'LAST_EDIT',
      },
      {
        colIndex: 1,
        dataKey: 'CompanyName',
        rowGuid: 'HeaderTC',
        rowIndex: 0,
        type: 'text',
        value: 'P_OR_C',
      },
      {
        colIndex: 2,
        dataKey: 'Status',
        rowGuid: 'HeaderTC',
        rowIndex: 0,
        type: 'text',
        value: 'STATUS',
      },
      {
        colIndex: 3,
        dataKey: 'ProgressPercentage',
        rowGuid: 'HeaderTC',
        rowIndex: 0,
        type: 'text',
        value: 'POGRESS',
      },
      {
        colIndex: 3,
        dataKey: '',
        rowGuid: 'HeaderTC',
        rowIndex: 0,
        type: 'text',
        value: 'ACTION',
      },
    ],
    rowGuid: 'HeaderTC',
    rowIndex: 0,
    rowType: 'header',
  }

  const handleKeywordChange = (keyw: string) => {
    updateState({...state, Keyword: keyw})
  }
  const handleSort = (sortCrit: {Sort: string; Order: 'asc' | 'desc'}) => {
    updateState({...state, ...sortCrit})
    setActiveSort(sortCrit)
  }

  useEffect(() => {
    dispatch(setProjectEditing(null))
  }, [])

  // useEffect()
  const parsedData = [tHeader, ...parseHomeDataToTable(data?.data || [], activeSort)]

  return (
    <>
      <div style={{height: '75vh ', backgroundColor: 'transparent'}} data-bs-theme={mode}>
        <div style={{height: 15}} data-bs-theme={mode}></div>
        <div
          className={'row h-100 m-0 p-0 '}
          data-bs-theme={mode}
          style={{backgroundColor: 'transparent'}}
        >
          <div
            data-bs-theme={mode}
            className={
              'd-flex d-sm-flex d-md-flex d-lg-flex d-xl-none flex-column col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 rounded m-0 p-0 mt-5 p-5 ' +
              (mode === 'dark' ? ' bg-black ' : ' bg-white ')
            }
          >
            <ProjectListHeader
              screenType='small'
              onAddPress={onAddPress}
              onKeywordChange={handleKeywordChange}
            />
            <ProjectTable
              data={parsedData}
              screenType='small'
              onSort={handleSort}
              activeSort={activeSort}
            />
          </div>
          <div
            data-bs-theme={mode}
            className={
              'd-none d-sm-none d-md-none d-lg-none d-xl-flex flex-column col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 h-100 rounded m-0 p-0 mt-5 p-5 ' +
              (mode === 'dark' ? ' bg-black ' : ' bg-white ')
            }
          >
            <ProjectListHeader
              screenType='large'
              onAddPress={onAddPress}
              onKeywordChange={handleKeywordChange}
            />
            <ProjectTable
              data={parsedData}
              screenType='large'
              onSort={handleSort}
              activeSort={activeSort}
            />
          </div>
          <div
            data-bs-theme={mode}
            className=' d-none d-sm-none d-md-none d-lg-none d-xl-flex col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 m-0 p-0 d-flex flex-column ms-auto'
            style={{width: '32%'}}
          >
            {/* , {[style['home-btn']]: true, [style['btn-fm']]: true} */}
            <div
              data-bs-theme={mode}
              className={clsx(
                'rounded  m-0 p-0 ms-auto me-auto mt-5 overflow-hidden cursor-pointer '
              )}
              style={{width: '100%'}}
            >
              <a href='https://www.chastagner.fr/materiels' target='_blank'>
                <img src={'/media/images/btn-fm.png'} alt='BTN-FM' className='w-100' />
              </a>
            </div>
            <div style={{height: 20}}></div>
            {/* , {[style['home-btn']]: true, [style['btn-fm']]: true} */}
            <div
              data-bs-theme={mode}
              className={clsx('rounded m-0 p-0 ms-auto me-auto overflow-hidden cursor-pointer ')}
              style={{width: '100%'}}
            >
              <a
                href='https://it2v7.interactiv-doc.fr/html/chastagner_catalogue_location_850/'
                target='_blank'
              >
                <img src={'/media/images/btn-fp.png'} alt='BTN-FM' className='w-100' />
              </a>
            </div>
          </div>
          {/* <div className='d-flex d-sm-flex d-md-flex d-lg-flex d-xl-none' style={{height: 10}}></div> */}
          <div
            className='d-flex d-sm-flex d-md-none d-lg-none d-xl-none flex-column col-12 m-0 p-0 d-flex justify-content-between mt-5'
            style={{width: '100%'}}
            data-bs-theme={mode}
          >
            {/* , {[style['home-btn']]: true, [style['btn-fm']]: true} */}
            <div
              className={clsx(
                'rounded m-0 p-0 ms-auto me-auto mt-5 overflow-hidden cursor-pointer '
              )}
              style={{width: '100%'}}
              data-bs-theme={mode}
            >
              <img src={'/media/images/btn-fm.png'} alt='BTN-FM' className='w-100' />
            </div>
            {/* , {[style['home-btn']]: true, [style['btn-fm']]: true} */}
            <div style={{height: 20}} data-bs-theme={mode}></div>
            <div
              className={clsx(
                'rounded m-0 p-0 ms-auto me-auto mt-5 overflow-hidden mt-auto cursor-pointer '
              )}
              style={{width: '100%'}}
              data-bs-theme={mode}
            >
              <img src={'/media/images/btn-fp.png'} alt='BTN-FM' className='w-100' />
            </div>
          </div>

          <div
            className='d-none d-sm-none d-md-flex d-lg-flex d-xl-none flex-row col-12 m-0 p-0 d-flex justify-content-between mt-5'
            style={{width: '100%'}}
            data-bs-theme={mode}
          >
            {/* , {[style['home-btn']]: true, [style['btn-fm']]: true} */}
            <div
              className={clsx('col-5 rounded m-0 p-0 mt-5 overflow-hidden mb-auto cursor-pointer ')}
              style={{width: '45%'}}
              data-bs-theme={mode}
            >
              <a href='https://www.chastagner.fr/materiels' target='blank'>
                <img src={'/media/images/btn-fm.png'} alt='BTN-FM' className='w-100' />
              </a>
            </div>
            {/* , {[style['home-btn']]: true, [style['btn-fm']]: true} */}
            <div
              className={clsx('col-5 rounded m-0 p-0 mt-5 overflow-hidden mb-auto cursor-pointer ')}
              style={{width: '45%'}}
              data-bs-theme={mode}
            >
              <a
                href='https://it2v7.interactiv-doc.fr/html/chastagner_catalogue_location_850/'
                target='blank'
              >
                <img src={'/media/images/btn-fp.png'} alt='BTN-FM' className='w-100' />
              </a>
            </div>
          </div>
          <div
            className='d-flex d-sm-flex d-md-flex d-lg-flex d-xl-none'
            style={{height: 50}}
            data-bs-theme={mode}
          ></div>
        </div>
      </div>
    </>
  )
}

export default HomePage
